// frontend/src/components/auth/GoogleLoginButton.js
import React, { useEffect, useRef } from 'react';
import { Button } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom'; 

const GoogleLoginButton = ({ variant = 'primary', text = 'Iniciar con Google' }) => {
  const { login } = useAuth();
  const buttonRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://accounts.google.com/gsi/client';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    script.onload = () => {
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleGoogleResponse,
        auto_select: false,
        cancel_on_tap_outside: true
      });

      if (variant === 'outline') {
        // Para el navbar, usar botón personalizado
        if (buttonRef.current) {
          buttonRef.current.style.display = 'block';
          
        }
      } else {
        window.google.accounts.id.renderButton(
          buttonRef.current,
          {
            theme: variant === 'primary' ? 'filled_blue' : 'outline',
            size: 'large',
            text: 'signin_with',
            shape: 'rectangular',
            width: buttonRef.current?.offsetWidth
          }
        );
      }
    };

    return () => {
      document.body.removeChild(script);
    };
  }, [variant]);

  const handleGoogleResponse = async (response) => {
    const result = await login(response);

    if (result.success) {
      navigate(result.user?.hasOnboarded ? '/dashboard' : '/onboarding');
    }
  };

  // Para variante outline, usar botón personalizado
  if (variant === 'outline') {
    return (
      <Button 
        variant="outline-primary" 
        className="d-flex align-items-center gap-2"
        onClick={() => {
          if (window.google) {
            window.google.accounts.id.prompt();
          }
        }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24">
          <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
          <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
          <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
          <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
        </svg>
        {"Ingresar"}
      </Button>
    );
  }

  return (
    <div 
      ref={buttonRef}
      className="d-flex justify-content-center"
      style={{ minHeight: '40px' }}
    />
  );
};

export default GoogleLoginButton;